import { routesNames } from '@/core/constants'
import NaoEncontrada from '@/views/pages/comum/pagina-nao-encontrada/PaginaNaoEncontrada.vue'

export default [
	{
		path: '/',
		redirect: () => ({ name: routesNames.ATA.ATA_VIEW }),
	},
	{
		name: routesNames.COMUM.PAGINA_NAO_ENCONTRADA,
		path: '*',
		component: NaoEncontrada,
		meta: {
			page: {
				title: 'Oops',
				subtitle: 'Página não encontrada',
			},
		},
	},
]
